import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import { configureStore } from "redux/store"
import "./interceptors/axios"
import "remixicon/fonts/remixicon.css"
import { isProd } from "utils/networking"
import "i18n"

export const store = configureStore({})
console.log("VER:", "1.3.6")

const sentryDSN = process.env.REACT_APP_SENTRY_DSN

if (sentryDSN && isProd && process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: sentryDSN,
    integrations: [new BrowserTracing()],
    environment: isProd ? "production" : "other",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // ResizeObserver ignore rule set due:
    // - We don't use ResizeObserver anywhere in our codebase
    // - There are actual bugs from Chromium browsers that wrongly trigger this warning, please see:
    //   - https://issues.chromium.org/issues/41369140
    //   - https://sentry.io/answers/react-resizeobserver-loop-completed-with-undelivered-notifications/
    //   - https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    ignoreErrors: ["ResizeObserver loop limit exceeded"],
  })
}

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <App />
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
